module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/account-statement/account-statement.component.css
// module id = ./src/app/account-statement/account-statement.component.css
// module chunks = main